
import { Component, Vue } from 'vue-property-decorator'
import { MemberIVO, MstMemberVO } from '@/views/biz/join/vo/join.vo'
import { MstPointHistoryVO, MypageOVO } from '@/views/biz/mypage/vo/mypage.vo'
import DeliveryAddressChoicePop from '@/views/biz/order/DeliveryAddressChoicePop.vue'
import axios from 'axios';
import CommonUtils from '@/common-utils';
import channelIO from "@/assets/js/channel-io";
import Constants from '../../../constants';
import { MemberNotificationSettingGroupVO, NotificationSettingVO } from './vo/mypage.vo'

// 글로벌에서만 채팅 사용함
let channel;
if (CommonUtils.isSystemLocale("global") == true) {
  channel = new channelIO();
}

@Component({
  components: { DeliveryAddressChoicePop }
})
export default class Profile extends Vue{
  member = {} as MstMemberVO;
  notifications = [] as Array<MemberNotificationSettingGroupVO>;
  memberIVO: MemberIVO = {} as MemberIVO;
  memMailingType = '02';
  isSendedNotiPoint = [] as Array<boolean>;
  sumPoint = [] as Array<number>;
  pointStatus = {} as Map<string,string>;
  
  // 주소록(배송지) 팝업
  showDeliveryAddressChoicePop = false;

  saveButtonState(){
    // 일반알림 상태 저장
    axios.put('/mypage/profile/mailing-type', this.notifications[0]);

    // 래플알림 상태 저장
    axios.put('/mypage/profile/mailing-type', this.notifications[1]);

    // 마케팅 수신 상태 저장
    axios.put('/join', this.memberIVO);
  }
  
  // 알림 수신 여부 저장
  async saveMailingType(noti: NotificationSettingVO) {
    // 현재 설정된 버튼설정
    const currentMailingTypes = [this.memMailingType,this.notifications[0].mailingType,this.notifications[1].mailingType];
    const lookupTable = {'000000':0,'050001':1,'050002':2};

    this.memberIVO.mailingType = this.memMailingType;

    // 클릭한 코드
    const clickNotiCd = (noti == null ? '000000' : noti.notificationSettingTypeCd);

    // 클릭한 코드 기반으로 액션코드 생성
    const actionCd = clickNotiCd + '-' + currentMailingTypes[lookupTable[clickNotiCd]];

    // 각 액션코드에 대한 버튼설정 테이블 (01 : ON,  02 : OFF,  currentMailingTypes[N] : 현 상태 유지)
    const actionTable = {
      '000000-01' : ['01',                    '01',                   '01'                  ],
      '050001-01' : [currentMailingTypes[0],  '01',                   currentMailingTypes[2]],
      '050002-01' : [currentMailingTypes[0],  currentMailingTypes[1], '01'                  ],

      '000000-02' : ['02',                    currentMailingTypes[1], '02'                  ],
      '050001-02' : [currentMailingTypes[0],  '02',                   currentMailingTypes[2]],
      '050002-02' : [currentMailingTypes[0],  currentMailingTypes[1], '02'                  ]
    };

    // 이미 포인트가 지급된 사람에게 해지 시 포인트가 회수된다는 확인메세지 전송 (확인메세지 결과에 따라 처리)
    if(!this.checkPublishedPoint(this.isSendedNotiPoint[lookupTable[clickNotiCd]],actionCd)) return;

    // 알림버튼 설정값 적용
    this.memMailingType = actionTable[actionCd][0];
    this.$set(this.notifications[0], "mailingType", actionTable[actionCd][1]);
    this.$set(this.notifications[1], "mailingType", actionTable[actionCd][2]);

    // 버튼상태 저장
    this.saveButtonState();


    // 체크박스 상태 저장 및 포인트 지급
    const mnsg = {
      notificationSettingTypeCd : '000000',
      mailingType : this.memMailingType,
      memCd : this.member.memCd
    } as MemberNotificationSettingGroupVO;

    // 마케팅 수신동의 버튼 상태에 따른 포인트 지급 및 회수 처리
    switch(actionCd){
      case '000000-01':
      case '000000-02':
        axios.put('/mypage/profile/point', mnsg).then(r=>{
          // 포인트 발급여부 상태 조회 (마케팅 수신동의(20)) / 리로드
          this.getNotificationPointHistory('20');
        });
      break;
    }

    // 일반알림 수신동의 버튼 상태에 따른 포인트 지급 및 회수 처리
    switch(actionCd){
      case '000000-01':
      case '050001-01':
      case '050001-02':
        axios.put('/mypage/profile/point', this.notifications[0]).then(r=>{
          // 포인트 발급여부 상태 조회 (일반알림 수신동의(21)) / 리로드
          this.getNotificationPointHistory('21'); 
        });
      break;

    }

    // 포인트 지급된 사례가 없는 상태에서 알림을 ON 했을 때 보여주는 알림 메세지
    if(((actionCd == '000000-01' && !this.isSendedNotiPoint[0]) || (actionCd == '050001-01' &&  !this.isSendedNotiPoint[1]))){
      alert('설정 완료되었습니다. 포인트는 24시간 이후에 지급됩니다.');
    }
  }

  // 포인트 지급여부 조회
  async getNotificationPointHistory(memPointType: string){
    const hist: MstPointHistoryVO = {} as MstPointHistoryVO;

    hist.memPointType = memPointType;
    hist.memCd = this.member.memCd;

    //  isSendedNotiPoint[0] : 마케팅 수신동의 (코드 20)
    //  isSendedNotiPoint[1] : 일반알림 수신동의 (코드 21)
    return await axios.get('/mypage/profile/point-history',{params : hist}).then(r=>{
      if(r.data.memPointType == '20'){
        this.isSendedNotiPoint[0] = (r.data.regDate == null ? false : true);
        this.sumPoint[0] = r.data.point;
        this.pointStatus["000000"] = r.data.status;
      }
      else if(r.data.memPointType == '21'){
        this.isSendedNotiPoint[1] = (r.data.regDate == null ? false : true);
        this.sumPoint[1] = r.data.point;
        this.pointStatus["050001"] = r.data.status;
      }
    });
  }

  checkPublishedPoint(isSendedNotiPoint: boolean, actionCd: string): boolean {
    // 포인트 지급됐었고 마케팅 수신동의 해지 시 포인트 차감 안내 문구 출력
    // 포인트 지급됐었고 일반알림 수신동의 해지 시 포인트 차감 안내 문구 출력
    // 단, 알림관련 포인트 지급 이력의 합계가 0 '초과'일 경우에만 해당 문구를 출력한다
    if((isSendedNotiPoint && actionCd == '000000-02' && (this.sumPoint[0]>0)) ||(isSendedNotiPoint && actionCd == '050001-02' && (this.sumPoint[1]>0))){

      if(this.pointStatus[actionCd.split("-")[0]] != '03'){
        if(confirm('설정 해지 시 지급된 포인트가 차감됩니다. 알림을 해지하시겠습니까?')) return true;
      }
      else{
        return true;
      }

      // 체크박스 활성화 상태로 되돌려야 함
      if(actionCd == '000000-02'){
        this.$nextTick().then(() => {
          this.memMailingType = '01';
        });
        console.log("해지 취소 처리 (마케팅 수신동의)");
      }
      else if(actionCd == '050001-02'){
        this.$nextTick().then(() => {
          this.$set(this.notifications[0], "mailingType", '01');
        });
        console.log("해지 취소 처리 (일반알림 수신동의)");
      }
        
      return false;
    }

    // 리턴값이 true 일 경우 계속 진행
    return true;
  }


  //methods
  doLogout(): void {
    // 로그아웃
    CommonUtils.logout(this);
  }

  // 프로필 사진 업로드
  fileUpload(e) {
    console.log(e.target.files[0])
    const formData = new FormData();
    formData.append("file", e.target.files[0])
    formData.append("bizType", 'profile')
    // 사진 업로드
    axios.post('/common/file/upload', formData, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(r => {
      const param = {} as MypageOVO;
      param.memProfileFileCd = r.data[0].fileCd;

      // 회원정보 저장
      axios.put('/mypage/profile', param)
      .then(r => {
        this.member = r.data;

        // 챗팅 정보 업데이트
        if (channel) {
          channel.updateMember(this.member);
        }
      })
    }, err => {
      console.error(err)
    })
  }

  // 파일 트리거
  triggerFile() {
    const input = this.$refs.memProfile as HTMLInputElement;
    input.click();
  }

  created(): void {
    axios.get('/mypage/profile/mailing-types')
    .then(r=>{
      this.member = r.data.member;
      this.notifications = r.data.notifications;

      this.memMailingType = this.member.mailingType;
    })

    // 포인트 발급여부 상태, 알림관련 지급 포인트 합계 초기화
    this.isSendedNotiPoint[0] = false;
    this.isSendedNotiPoint[1] = false;
    this.sumPoint[0] = 0;
    this.sumPoint[1] = 0;

    // 포인트 발급여부 상태 조회 (마케팅 수신동의(20), 일반알림 수신동의(21))
    this.getNotificationPointHistory('20');
    this.getNotificationPointHistory('21'); 
  }
}
